import React from 'react'
import { Route, Routes } from 'react-router-dom'
import { AdminRoleCreateView } from './AdminRoleCreateView'
import { AdminRolesListView } from './AdminRolesListView'
import { AdminRoleDetailView } from './AdminRoleDetailView'
import { AdminRoleEditView } from './AdminRoleEditView'

export const AdminRolesView: React.FC = () => {
  return (
    <Routes>
      <Route index element={<AdminRolesListView />} />
      <Route path="level/:accessLevel" element={<AdminRolesListView />} />
      <Route path="user/new" element={<AdminRoleCreateView />} />
      <Route path="user/edit/:id" element={<AdminRoleEditView />} />
      <Route path="user/:id" element={<AdminRoleDetailView />} />
    </Routes>
  )
}
